import React, { useState } from 'react';
import { Confirm, useRefresh, useNotify, useTranslate, useRecordContext } from 'react-admin';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import IconButton from '../../common/buttons/IconButton';

import { publishEvent, unpublishEvent } from '../../../services/api';

const PublishButton = ({ variant, color }) => {
	const record = useRecordContext();
	const refresh = useRefresh();
	const notify = useNotify();
	const translate = useTranslate();
	const [showDialog, setShowDialog] = useState(false);

	const handlePublish = async () => {
		const response = await publishEvent(record.id);
		if (response.success) {
			refresh();
			notify(translate('Event published'));
		}

		handleClose();
	};

	const handleUnpublish = async () => {
		const response = await unpublishEvent(record.id);
		if (response.success) {
			refresh();
			notify(translate('Event unpublished'));
		}

		handleClose();
	};

	const handleOpen = () => {
		setShowDialog(true);
	};

	const handleClose = () => {
		setShowDialog(false);
	};

	if (!record || record.status !== 'accepted') {
		return null;
	}

	if (record.published) {
		return (
			<>
				<IconButton icon={<VisibilityOffIcon />} onClick={handleOpen} variant={variant} color={color}>{translate('Unpublish')}</IconButton>
				<Confirm
					isOpen={showDialog}
					title={translate('Unpublish')}
					content={translate('Do you want to unpublish the event') + ` ${record.title}?`}
					onConfirm={handleUnpublish}
					onClose={handleClose}
				/>
			</>
		);
	}

	return (
		<>
			<IconButton icon={<VisibilityIcon />} onClick={handleOpen} variant={variant} color={color}>{translate('Publish')}</IconButton>
			<Confirm
				isOpen={showDialog}
				title={translate('Publish')}
				content={translate('Do you want to publish the event') + ` ${record.title}?`}
				onConfirm={handlePublish}
				onClose={handleClose}
			/>
		</>
	);
};

export default PublishButton;